import { render } from "./LaunchYourProduct.vue?vue&type=template&id=54dd5aac&scoped=true&ts=true"
import script from "./LaunchYourProduct.vue?vue&type=script&lang=ts"
export * from "./LaunchYourProduct.vue?vue&type=script&lang=ts"

import "./LaunchYourProduct.vue?vue&type=style&index=0&id=54dd5aac&scoped=true&lang=scss"

import exportComponent from "D:\\_dev\\engenious-pl\\public-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54dd5aac"]])

export default __exports__